import { Component, Prop, h, Watch } from '@stencil/core';
import { getReviewListData, getThumbStatusData } from '@ugc-components/ugc-pdp-review/utils';
import state from '@ugc-store';
import { stringFormat, toLocalSeparator } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-review-list',
  shadow: false,
})
export class UgcReviewList {
  @Prop() productId: number;

  async getReviewList(isFirstRender = false) {
    const {
      preference: { language },
      isDesktop,
    } = state;

    await getReviewListData({ productId: this.productId, language, isFirstRender: isFirstRender && !isDesktop });

    await getThumbStatusData();
  }

  async componentWillLoad() {
    this.getReviewList(true);
  }

  @Watch('productId')
  async watchProductIdHandler() {
    this.getReviewList();
  }

  render() {
    const {
      reviewStaticLanguage: { IDS_LBL_SEE_ALL_REVIEWS = '' } = {},
      ids = [],
      reviewBreakUpById,
      reviewTotalCount,
      productInfo: { urlName = '', partNumber = '' },
      isDesktop,
      isShowReviewSkeleton,
    } = state;

    if (isShowReviewSkeleton) return <ugc-review-list-keleton />;

    if (!ids.length) return null;

    return (
      <div>
        {/* "ugc-review-item-desktop-wrap" is used for add scroll ga */}
        {ids.map(id => (
          <div
            class={`ugc-review-item-desktop-wrap ${
              isDesktop
                ? 'mb-16 bg-white p-24 border-1 border-solid border-gray-300 rounded-16'
                : 'py-16 border-bottom-solid border-1 border-gray-300'
            }`}
            key={id}
          >
            <ugc-review-item reviewItem={reviewBreakUpById[id]} />
          </div>
        ))}
        <div class={`${!isDesktop && 'h-40'} flex-row-center-center`}>
          <ugc-read-more
            isBetween={!isDesktop}
            isReview={true}
            partNumber={partNumber}
            href={`${state.domains.catalog || ''}/r/${urlName}/${this.productId}`}
            data-testid="pdp-qna-see-all-review"
          >
            <span class="bold">{stringFormat(IDS_LBL_SEE_ALL_REVIEWS, toLocalSeparator(reviewTotalCount))}</span>
          </ugc-read-more>
        </div>
      </div>
    );
  }
}
